export default __webpack_public_path__ + "static/media/GH_kitchen.ca4432a2.webp";